import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import FernrauschApp from './components/app/FernrauschApp';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
    <FernrauschApp/>
);
